import React, { useEffect, useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Layout from "../inc/layout-frontend";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import PaysService from "../../services/PaysService";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import { removeFromCart, resetCart } from "../../app/providers/panierSlice";
import { app_url } from "../../services/http";
import Table from 'react-bootstrap/Table';
import CommandesService from "../../services/CommandesService";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../../app/providers/authSlice";
import ModepaiementsService from "../../services/ModepaiementsService";
import { openKkiapayWidget, addKkiapayListener, removeKkiapayListener, } from "kkiapay";
import Pagination from 'react-bootstrap/Pagination';

export default function Paiement() {

  const [user, setUser] = useState({});

  const [pays, setPays] = useState([]);

  const [currentPage, setCurrentPage] = useState(1);

  const [publications, setPublications] = useState([]);


  const itemsPerPage = 5; // Nombre d'éléments par page

  const data = publications;

  const indexOfLastItem = currentPage * itemsPerPage;

  const indexOfFirstItem = indexOfLastItem - itemsPerPage;

  const publication = data.slice(indexOfFirstItem, indexOfLastItem);

  const [commandes, setCommandes] = useState([]);

  const [modepaiements, setModepaiements] = useState([]);

  const [modepaiement_id, setModepaiement_id] = useState('');

  // Déclaration de l'état et de la fonction pour la référence de commande
  const [commandeReference, setCommandeReference] = useState('');

  // Déclaration de l'état et de la fonction pour le montant total de commande
  const [commandeMontantTotal, setCommandeMontantTotal] = useState('');

  const dispatch = useDispatch();

  const auth = useSelector(state => state.auth)

  const token = useSelector(state => state.auth.token)

   // Nouvel état local pour gérer l'affichage du "loading"
   const [isLoading, setIsLoading] = useState(false);


  const location = useLocation()

  const navigate = useNavigate();

  dispatch(checkAuthenticate())

  if (!auth.isAuthenticate) {
    navigate(myroutes.login)
  }


  const { contentPanier } = useSelector(state => state.panier);

  const startIndex = (currentPage - 1) * itemsPerPage;

  const endIndex = startIndex + itemsPerPage;

  const paginatedData = contentPanier.slice(startIndex, endIndex);

  const fetchCommandes = async () => {
    try {
      const response = await CommandesService.index(auth.user.id, token);
      setCommandes(response.data.liste_commandes);
      //alert(auth.user.id);
      console.log(response.data);
    } catch (error) {
      console.error(error);
    }

  };

  const fetchModepaiements = async () => {
    try {
      const response = await ModepaiementsService.index(token);
      setModepaiements(response.data.modepaiements);
      //alert(auth.user.id);
      //console.log(response.data.modepaiements);
    } catch (error) {
      console.error(error);
    }

  };


  const handlePaiement = async (event) => {
    event.preventDefault();

    const createdById = auth.user ? auth.user.id : null;
    const updatedById = auth.user ? auth.user.id : null;

    const commande = {
      id: location.state ? location.state.commande_id : 0,
      montant_total: contentPanier.reduce((acc, item) => acc + item.price * item.quantity, 0),
      statut_id: location.state ? location.state.statut_id : null,
      created_by: createdById,
      updated_by: updatedById,
      contenuPanier: contentPanier,
      reference: location.state ? location.state.commande_reference : null, // Remplacez cette valeur par la valeur du champ de référence de transaction
  
  };

    // console.log(commande.statut_id);
  
    /*const paiement = {
      commande_id: commande.id, // Remplacez cette valeur par l'ID de la commande
      montant_total: commande.montant_total,
      mode_paiement: modepaiement_id, // Remplacez cette valeur par l'ID du mode de paiement sélectionné
      telephone: auth.user.telephone, // Remplacez cette valeur par la valeur du champ de téléphone
      reference: location.state ? location.state.commande_reference : null, // Remplacez cette valeur par la valeur du champ de référence de transaction
    };*/

    try {
      
    /*  console.log("**********");
      console.log(commande.statut_id);
      console.log("**********");*/

    
      // Vérifier si la commande a déjà un statut de 5 (validé)
      /*if (commande.statut_id === 5) {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Vous avez déjà une commande en attente de paiement.',
        });
      } else {*/
      if (commande.id || (commande.id && commande.statut_id === 6)) {
        //alert(modepaiement_id)
        if (modepaiement_id == 1) //1 pour kkiapay
        {
         // alert(modepaiement_id)
          //lancer kkiapay
          //get public key
          //Ancienne clé DGBOOK
          //var key = 'a99479201afd11ebb8328f6d383a7ac2';

          //Cle kiosque digital
          var key = 'a3d7ba102c2c11eca034c583a09af15d';
          openKkiapayWidget({
            amount: commande.montant_total,
            position: "center",
            data: commande.reference,
            name: auth.user.fullname,
            theme: "blue",
            api_key: key,
            sandbox: true,
            email: auth.user.email,
            phone: auth.user.telephone,
          });
        }else{
           Swal.fire({
          icon: 'error',
          title: 'Oups !!!',
          text: 'Cet mode de paiement n\'est pas disponible pour le moment.',
        });
        }

      } else {
        Swal.fire({
          icon: 'error',
          title: 'Erreur',
          text: 'Vous avez déjà une commande enregistrée avec cet id.',
        });
  
    }
      // Reste du code...
     /* if (commande.id && commande.statut_id === 6) {
        if (modepaiement_id == 1) {
          alert("oki" + '' + commande.id)
        } else {
          alert("no modepaiement")
        }
      } else {
        alert ("non oki")
      }*/
     
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Erreur',
        text: 'Une erreur s\'est produite lors de l\'enregistrement du paiement.',
      });
      console.error(error);
    }
  };


  useEffect(() => {
    // Mise à jour de la dernière commande lorsque le tableau `commandes` change
    if (commandes && commandes.length > 0) {
      // Filtrer les commandes de l'utilisateur actuel
      const userCommandes = commandes.filter(commande => commande.created_by === auth.user.id);

      if (userCommandes.length > 0) {
        // Trier les commandes par date de création (ou une autre propriété)
        userCommandes.sort((a, b) => new Date(b.date_creation) - new Date(a.date_creation));

        const lastUserCommande = userCommandes[0]; // Sélectionner la première commande (la plus récente)

        setCommandeReference(lastUserCommande.reference);
        setCommandeMontantTotal(lastUserCommande.montant_total);
      }
    };


  }, [commandes, auth.user]);

  //Script paiement
  //Get kkiapay reponse after paiement success
  const successHandler = async (response) => {
    //console.log(response);
    //check transaction statut
    /*CommandesService.checkTransactionStatut(response, token).then((result) => {
      console.log(result);
    })*/

    const paiementsInfo = {
      commande_id: location.state ? location.state.commande_id : 0, // Remplacez cette valeur par l'ID de la commande
      montant_total: contentPanier.reduce((acc, item) => acc + item.price * item.quantity, 0),
      mode_paiement: 1,//modepaiement_id, // Remplacez cette valeur par l'ID du mode de paiement sélectionné 1 pour MOMO
      telephone: auth.user.telephone, // Remplacez cette valeur par la valeur du champ de téléphone
      reference: location.state ? location.state.commande_reference : null, // Remplacez cette valeur par la valeur du champ de référence de transaction
    };
   

    //Recuperation du code de la transaction de kkiapay
    var code_transaction = response.transactionId
    // Enregistrer le paiement
    CommandesService.paiement(code_transaction, paiementsInfo, auth.token).then((res) => {
      //console.log(res)
      if (res.data.transaction) {
        Swal.fire({
          icon: 'success',
          title: 'Enregistrement réussi',
          text: res.data.transaction.message,
        });
         // Réinitialiser le panier après la validation du paiement
        dispatch(resetCart());
        // Navigation sur la page de confirmation
        navigate(myroutes.confirmation);
      } else if (res.data.echec) {
        Swal.fire({
          icon: 'warning',
          title: 'Une erreur s\'est produite !',
          text: res.data.echec,
        });
      } else if (res.data.erreur) {
        Swal.fire({
          icon: 'error',
          title: 'Erreur!',
          text: res.data.erreur,
        });
      }
    }).catch(error => {
      console.log("Error", error);
    });

  }

  useEffect(() => {
    fetchCommandes();
    fetchModepaiements();
    addKkiapayListener('success', successHandler)
    return () => {
      removeKkiapayListener('success', successHandler)
    };
  }, []);


  return (
    <Layout>
      <div className="container-fluid position-relative p-0">
        <div className="container-fluid bg-primary py-5 bg-header" style={{ marginBottom: "90px" }}>
          <div className="row py-5">
            <div className="col-12 pt-lg-5 mt-lg-5 text-center">
              <h1 className="display-4 text-white animated zoomIn">Paiement</h1>
              <Link className="h5" style={{ color: "goldenrod" }} to={myroutes.homepage}>
                Accueil
              </Link>
              <i className="far fa-circle text-white px-2"></i>
              <Link className="h5 text-white">Paiement</Link>
            </div>
          </div>
        </div>
      </div>
      <Container>
        <Row>
          <Col sm={6}>
            <h3 className="mb-4">Informations personnelles</h3>
            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>
            <Form onSubmit={handlePaiement}>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Identifiant <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande " type="text" value={auth.user?.fullname} readOnly />
              </Form.Group>
              <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>Email <i style={{ color: "red" }}>*</i></Form.Label>
                <Form.Control className="form-commande " type="text" value={auth.user?.email} readOnly />
              </Form.Group>

              {commandes && commandes.length > 0 && (
                <>
                  <h5 style={{ fontSize: "22px" }} className="mb-3 mt-5">
                    Paiement de la commande N°{" "}
                    <span className="badge badge-primary" style={{ fontSize: "24px" }}>
                      {commandeReference}
                    </span>
                  </h5>
                  <div className="row px-0 mb-4">
                    <div className="trait"></div>
                  </div>
                  <p>Merci de renseigner votre mode de paiement dans ce formulaire</p>

                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                      N° Commande <i style={{ color: "red" }}>*</i>
                    </Form.Label>
                    <Form.Control className="form-commande" type="text" value={commandeReference} readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                      Montant Total <i style={{ color: "red" }}>*</i>
                    </Form.Label>
                    <Form.Control className="form-commande" type="text" value={commandeMontantTotal} readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                      Téléphone <i style={{ color: "red" }}>*</i>
                    </Form.Label>
                    <Form.Control className="form-commande" type="text" value={auth.user?.telephone} readOnly />
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                    <Form.Label style={{ fontWeight: "bold", fontSize: "16px" }}>
                      Mode paiement <i style={{ color: "red" }}>*</i>
                    </Form.Label>
                    <Form.Control
                      as="select"
                      className="form-commande"
                      type="text"
                      value={modepaiement_id}
                      onChange={(e) => setModepaiement_id(e.target.value)}
                      required
                    >
                      <option value="">Sélectionnez un mode de paiement</option>
                      {modepaiements.map((modepaiement) => (
                        <option key={modepaiement.id} value={modepaiement.id}>
                          {modepaiement.libelle}
                        </option>
                      ))}
                    </Form.Control>
                  </Form.Group>
                </>
              )}

              <Button className="me-3 mt-4 mb-5" type="submit" variant="primary" style={{ padding: "15px", borderRadius: "4px" }}>Procéder au paiement</Button>{' '}
            </Form>

          </Col>

          <Col sm={1} style={{ minHeight: "100px", backgroundColor: "white" }}>

          </Col>
          <Col sm={5} style={{}}>
            <h3 className="mb-4">Détails de la commande</h3>
            <div className="row px-0 mb-4">
              <div className="trait"></div>
            </div>

            <Table striped bordered hover size="sm" >
              <thead style={{ backgroundColor: "#116BB9", color: "white", fontSize: "18px" }}>
                <tr>
                  <th style={{ padding: "10px", width: "600px" }}>Parution</th>
                  <th style={{ padding: "10px", width: "200px" }}>Prix</th>
                  <th style={{ padding: "10px", width: "200px" }}>Quantité</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData.map((item) => (
                  <tr key={item.id}>

                    <td style={{ padding: "10px", alignItems: "center" }}>
                      <img
                        src={app_url + "/storage/laune/" + item.laune}
                        alt="Image"
                        style={{ width: '50px', height: '70px' }}
                      />
                      <p style={{ marginLeft: "10px", fontSize: "14px", lineHeight: "1.5rem" }}>{item.name}</p>
                    </td>


                    <td style={{ verticalAlign: "middle" }}>{item.price}</td>

                    <td style={{ verticalAlign: "middle" }}>
                      <span style={{ margin: "10px" }}>{item.quantity}</span>
                      <Button onClick={() => dispatch(removeFromCart(item))} variant="danger">
                        <i className="fa fa-trash" aria-hidden="true"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot style={{ backgroundColor: "rgb(199, 222, 255)" }}>
                <tr>
                  <th colSpan={4} style={{ padding: "10px", textAlign: "center", fontSize: "22px" }}>
                    <span > Total de la commande : {contentPanier.reduce((acc, item) => acc += item.price * item.quantity, 0)} FCFA</span>
                  </th>
                </tr>
              </tfoot>
            </Table>

            <div className="card mb-3 mt-5" style={{border:"1px solid grey"}}>
          <div className="card-body">
          <div className="mt-3">
          <p style={{fontWeight:"bold", color:"black", fontSize:"20px", fontStyle:"italic", textAlign:"center"}}> ( Nous acceptons <img src="../startup/img/modepaiement.png" alt="modepaiement" /> pour tous vos paiements | 100% sécurisée )</p>
          </div>
          </div>
          </div>
           
          </Col>
        </Row>
      </Container>
    </Layout>

  )
}
